import type { ILoadingProps } from "./Loading";

import classNames from "classnames";
import React from "react";

import Loading from "./Loading";

interface ISpinnerProps extends ILoadingProps {
  wrapperClassName?: string;
}

function Spinner({ wrapperClassName, size = "lg", ...props }: ISpinnerProps) {
  return (
    <div
      className={classNames(
        "d-flex justify-content-center align-items-center",
        wrapperClassName
      )}
    >
      <Loading size={size} {...props} />
    </div>
  );
}

export default Spinner;
